import { useEffect } from 'react';

import { amplitude } from '../utils';

export const useInitAmplitude = (isAutorizedUser: boolean = false) => {
  useEffect(() => {
    if (isAutorizedUser) {
      amplitude.init();
    }
  }, [isAutorizedUser]);
};

export const useAmplitudeSetUserId = (userId?: string) => {
  useEffect(() => {
    if (userId) {
      amplitude.setUserId(userId);
    }
  }, [userId])
};
